import { Injectable, inject } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IdValuePair } from "@tylertech/tyler-api-types";
import { UBAddAccountWizardCriteria } from "../interfaces";
@Injectable()
export class UBAccountService
{
    private readonly $apiService = inject(ApiService);


    createAccount(account: UBAddAccountWizardCriteria): Promise<UBAddAccountWizardCriteria>
    {
        return this.$apiService.sendAuth("IAccountService/CreateAccount", account);
    }

    getAllAccountClassCodes(): Promise<IdValuePair[]>
    {
        return this.$apiService.sendAuth("IAccountService/GetAllAccountClassCodes");
    }

    getNextFormattedAccountNumber(serviceAddressId: string): Promise<string>
    {
        return this.$apiService.sendAuth("IAccountService/GetNextFormattedAccountNumber", serviceAddressId);
    }
}
